/**
 * THE OWNER HUB'S DOORS ON THE CELL BUILD (move map M28). Grow, the Designer, the Library, Signature, Reviews, Check my
 * listing and Get on the TV post to the Owner Hub (image-os-web /pro/*), not to Supabase. Each of those screens asks
 * this file two things: which origin to call, and which sign-in token to present.
 *
 * - Production (the Cloudflare build, isCell() false): exactly what the screens did before — OWNER_HUB_ORIGIN or
 *   doorOrigin(), and this tab's Supabase access token from supabase.auth.getSession().
 * - The cell build: the Owner Hub's AWS staging host (CELL_OWNER_HUB_ORIGIN, VITE_TENEAN_WEB_ORIGIN) and this tab's
 *   Cognito ACCESS token. When that host is not set the origin is null and the screen shows CELL_DOOR_OFF through its own
 *   error path — the cell build never calls production.
 */
import { CELL_OWNER_HUB_ORIGIN, isCell } from './config';
import { getCellSession } from './cognito';
import { supabase } from '../supabase';
import { OWNER_HUB_ORIGIN, doorOrigin } from '../hosts';

/** What a door screen says on the cell build while the Owner Hub's AWS staging host is not set. */
export const CELL_DOOR_OFF = 'This feature is not on the AWS staging build yet.';

/** The origin of the doors that used OWNER_HUB_ORIGIN (ig-refresh, ig-scan, designer, library, studio). Null = not
 *  on this build. */
export function ownerHubOrigin(): string | null {
  return isCell() ? CELL_OWNER_HUB_ORIGIN : OWNER_HUB_ORIGIN;
}

/** The origin of the doors that used doorOrigin() (tv, signature, reviews, checks — VITE_MEDIA_DOOR wins in
 *  production previews, as before). Null = not on this build. */
export function ownerHubDoorOrigin(): string | null {
  return isCell() ? CELL_OWNER_HUB_ORIGIN : doorOrigin();
}

/** This tab's own sign-in token for an Owner Hub door, or null when signed out. */
export async function ownerHubToken(): Promise<string | null> {
  // CELL (M28): Tenean's Cognito ACCESS token for the Owner Hub's doors (aws-webapp, 2026-10-22: the web task verifies
  // access tokens — token_use=access, client_id on its allowed list, app_user_id from the pre-token Lambda; the QA pro's
  // access token from the Pro Hub client carries app_user_id and location_ids, read 2026-10-22). Tenean's API calls keep
  // the ID token (lib/cell/api.ts); the API accepts either. Never Supabase's.
  if (isCell()) return (await getCellSession())?.accessToken ?? null;
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token ?? null;
}
